<div class="main-container">
  <p>
    Hello, stranger.
  </p>

  <p>
    My name is Juan David Hurtado. I'm an iOS Software Engineer and I'm currently located at <a href="https://en.wikipedia.org/wiki/Popayán" style="text-decoration: none;"><span class="city">Popayán</span></a>, Colombia.
    If you want to see some of the apps that I've built: <a href="https://apps.apple.com/us/developer/juan-david-hurtado/id1549596027" style="text-decoration: none;"><span class="link-1">here</span></a>.
  </p>

  <p>
    Just in case: I'm working at Wizeline as a consultant.
  </p>

  <br>
  <p>Thanks for passing by.</p>

  <div class="links">
    <div class="links-inner">
      <a href="https://github.com/juandahurt">
        <img class="link-child" src="assets/icons/github.svg">
      </a>
      <a href="https://www.linkedin.com/in/juandahurt/">
        <img class="link-child" src="https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg">
      </a>
    </div>
  </div>
</div>